import React, { createContext, useContext } from 'react';

/** Mirrors narrow layouts when G.AI or the actions pane consumes horizontal space (desktop). */
export type RightChromeLayoutContextValue = {
  copilotOpen: boolean;
  actionsPaneOpen: boolean;
};

const defaultValue: RightChromeLayoutContextValue = {
  copilotOpen: false,
  actionsPaneOpen: false,
};

export const RightChromeLayoutContext = createContext<RightChromeLayoutContextValue>(defaultValue);

export function useRightChromeLayout(): RightChromeLayoutContextValue {
  return useContext(RightChromeLayoutContext);
}
